export default {"src":"/_next/static/media/telegramShare.94f8c8ea.svg","height":13,"width":14,"blurWidth":0,"blurHeight":0};